<template>
	<div ref="rowWrapper">
		<div ref="animationTarget"></div>
	</div>
</template>

<script>
export default {
	props: ['data', 'columnClasses', 'ready'],
	data() {
		return {
			reveal: false
		}
	},
	methods: {
		setupListener() {
			window.addEventListener('scroll', this.handleScroll);
			window.addEventListener('resize', this.setMediaColumnHeight);
		},
		removeListener() {
			window.removeEventListener('scroll', this.handleScroll);
			window.removeEventListener('resize', this.setMediaColumnHeight);
		},
		handleScroll() {
			if (typeof this.$refs.animationTarget === 'undefined' || this.$refs.animationTarget === null) return;
			var element = (typeof this.$refs.animationTarget.$el !== 'undefined') ? this.$refs.animationTarget.$el : this.$refs.animationTarget
			var offsetTop = element.getBoundingClientRect().top
			if ( (window.pageYOffset - (window.pageYOffset - offsetTop)) <= window.innerHeight) {
				this.reveal = true;
				this.removeListener();
			}
		},
		setMediaColumnHeight() {
			if ((typeof this.$refs.rowWrapper === 'undefined' || this.$refs.rowWrapper === null) || (typeof this.$refs.animationTarget === 'undefined' || this.$refs.animationTarget === null)) {
				setTimeout(() => {
					this.setMediaColumnHeight();
				}, 500);
				return;
			}
			this.$refs.rowWrapper.style.minHeight = (window.innerWidth>=640) ? (this.$refs.animationTarget.clientHeight + 80) + 'px' : 'auto';
			if (typeof this.$refs.animationTarget.clientHeight !== 'undefined') this.$emit('heightChange')
		}
	},
	mounted() {
		if (this.ready) {
			this.setupListener();
		}
		this.setMediaColumnHeight();
	},
	destroy() {
		this.removeListener();
	},
	watch: {
		ready(newVal) {
			if (this.show) return;
			if (newVal) this.setupListener();
		}
	}
}
</script>